import axios from "axios";

export const getProgramPrice = async (program_id, program_type, program_length, guest_id, room_id, arrivalDate, init_length) => {
  try {
    const { data: { res } } = await axios.get(
      `https://kivach.ru/calc-new/api_new.php?method=prices_new&program_id=${program_id}&type_id=${program_type}&length=${program_length}&guest_id=${guest_id}&room_id=${room_id}&date=${arrivalDate}&init_length=${init_length}`
    );
    return res;
  } catch (error) {
    console.error("Error fetching program price:", error);
    return { sum: 0, discount: 0, discount_sum: 0, discount_text: '', discount_hide: 0 };
  }
};